import { ReactNode } from "react";

export type ILoginProviderProps = {
  children?: ReactNode;
};

type LoginPostActionNavigate = {
  type: "navigate";
  to: string;
  replace?: boolean;
};

type LoginPostActionContext = {
  ownerInfo?: {
    id?: string;
    name?: string;
    [key: string]: any;
  } | null;
  eoaAddress?: string | null;
  loginType?: string | number;
  isLoggedIn?: boolean;
};

type LoginPostActionNavigateDynamic = {
  type: "navigate_dynamic";
  toBuilder: (ctx: LoginPostActionContext) => string | Promise<string>;
  /**
   * 在执行动态跳转前等待 ownerInfo.id 就绪（异步等待，不阻塞主线程）
   */
  waitForOwnerInfo?: boolean;
  /**
   * waitForOwnerInfo 的超时时间，默认 3000ms
   */
  waitTimeoutMs?: number;
  /**
   * 等待超时或 toBuilder 结果为空时的兜底路径
   */
  fallbackTo?: string;
  replace?: boolean;
};

type LoginPostActionCallback = {
  type: "callback";
  run: () => void | Promise<void>;
};

type LoginPostActionComposed = {
  type: "composed";
  actions: LoginPostAction[];
};

export type LoginPostAction =
  | LoginPostActionNavigate
  | LoginPostActionNavigateDynamic
  | LoginPostActionCallback
  | LoginPostActionComposed;

export type LoginOpenOptions = {
  reason?: string;
  /**
   * 是否隐藏登录弹窗关闭按钮。用于需要强制完成登录的入口。
   */
  hideCloseButton?: boolean;
  /**
   * 用户手动关闭登录弹窗后的跳转目标。
   * 适用于允许关闭，但关闭后必须离开当前页面的场景。
   */
  closeNavigateTo?: string;
  /**
   * 登录成功后执行的动作
   * 支持三种类型：
   * 1. 导航到指定路径 { type: "navigate", to: string, replace?: boolean }
   * 2. 执行回调函数 { type: "callback", run: () => void | Promise<void> }
   * 3. 组合多个动作 { type: "composed", actions: LoginPostAction[] }
   * 4. 动态跳转 { type: "navigate_dynamic", toBuilder: (ctx: LoginPostActionContext) => string | Promise<string>, waitForOwnerInfo?: boolean, waitTimeoutMs?: number, fallbackTo?: string, replace?: boolean }
   */
  postLoginAction?: LoginPostAction;
  /**
   * 多次触发 open 时是否覆盖已有的待执行动作，默认 true（最后一次意图优先）
   */
  replacePending?: boolean;
  /**
   * 待执行动作有效期（毫秒），默认 5 分钟
   */
  expireMs?: number;
};

export type ILoginModalContext = {
  open?: (options?: LoginOpenOptions) => void;
  loginModalVisible?: boolean;
};

export const EDGEN_TO_EXT_LOGIN_KEY = "__EDGEN_TO_EXT_LOGIN_KEY__";
